import React from 'react';
import SanityImage from '../../SanityImage';

const ImageComponent = ({ value, isInline }) => (
  <SanityImage
    asset={value.asset}
    size={1536}
    alt={value.alt || ' '}
    loading="lazy"
    className="rounded-lg"
    style={{ display: isInline ? 'inline-block' : 'block' }}
  />
);

export default ImageComponent;
